<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="门店编码" prop="storeId">
        <el-input v-model="search.storeId" placeholder="请输入完整门店编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店名称" prop="storeName">
        <el-input v-model="search.storeName" placeholder="请输入门店名称（模糊）" clearable></el-input>
      </el-form-item>
      <el-form-item label="所在省份" prop="provinceCode">
        <el-select v-model="search.provinceCode" placeholder="请选择" clearable style="width: 100%" @change="provinceChange">
          <el-option v-for="item in provinceList" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在城市" prop="cityCode">
        <el-select v-model="search.cityCode" placeholder="请选择" clearable style="width: 100%" :disabled="!search.provinceCode">
          <el-option v-for="item in cityList" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户电话" prop="contactMobile">
        <el-input v-model="search.contactMobile" placeholder="请输入完整手机号" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收品类" prop="categoryList">
        <el-select v-model="search.categoryList" placeholder="请选择回收的品类" clearable multiple style="width: 100%">
          <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="旧机条码" prop="barcode">
        <el-input v-model="search.barcode" placeholder="请输入旧机条码" clearable></el-input>
      </el-form-item>
      <el-form-item label="旧机状态" prop="status">
        <el-select v-model="search.status" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="(val, key) in statusMap" :key="key" :label="val" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登记时间" prop="registerTime">
        <el-date-picker
          clearable
          v-model="registerTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="registerTimeOptions"
          @change="changeRegisterTime"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="抽检时间" prop="checkTime">
        <el-date-picker
          clearable
          v-model="checkTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="checkTimeOptions"
          @change="changeCheckTime"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="是否抽检" prop="sample">
        <el-select v-model="search.sample" placeholder="请选择" clearable style="width: 100%">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否一致" prop="consistent">
        <el-select v-model="search.consistent" placeholder="请选择" clearable style="width: 100%">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="inbound">入库</el-button>
      <el-button type="primary" size="medium" @click="openBatchDialog">批量入库导入</el-button>
      <el-button type="primary" size="medium" @click="exportExcel">导出</el-button>
      <div class="right-buttons">
        <el-button type="primary" size="medium" @click="handleSearch">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </div>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column label="序号" type="index" min-width="60" align="center"></el-table-column>
      <el-table-column label="旧机条码" prop="barcode" min-width="180"></el-table-column>
      <el-table-column label="旧机品类" prop="categoryName" min-width="120"></el-table-column>
      <el-table-column label="所属门店" prop="storeName" min-width="160"></el-table-column>
      <el-table-column label="门店编码" prop="storeId" min-width="170"></el-table-column>
      <el-table-column label="所在省份" prop="provinceName" min-width="100"></el-table-column>
      <el-table-column label="所在城市" prop="cityName" min-width="100"></el-table-column>
      <el-table-column label="用户姓名" prop="contactName" min-width="100"></el-table-column>
      <el-table-column label="联系电话" prop="contactMobile" min-width="130"></el-table-column>
      <el-table-column label="旧机状态" prop="statusName" min-width="100"></el-table-column>
      <el-table-column label="批次号" prop="batchNo" min-width="120"></el-table-column>
      <el-table-column label="操作" fixed="left" min-width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.rows"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="批量入库" :visible.sync="batchDialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="downloadImportTemplate">
              <div class="btnclass">
                <img src="@/assets/download.png" alt="" />
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="batchFileRef" @addUpload="batchFileAdd" @removeUpload="removeBatchFile" :title="'+导入excel文件'" :limit="1" v-if="showBatchUpload" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="batchDialogVisible = false">取 消</div>
        <div @click="submitBatchImport()">确认导入</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fileUpload from '@/components/Upload/fileUpload'
import { findAllProvince, findAllCity, getOldDeviceList, inboundOldDevice, importInbound, getCategory } from '@/api/thirdPartyTradeIn'

export default {
  name: 'oldDeviceQuery',
  components: {
    fileUpload
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      provinceList: [],
      cityList: [],
      registerTime: [],
      checkTime: [],
      // 回收品类选项：value 为品类ID（接口获取），label 为品类名称
      categoryList: [],
      statusMap: {
        0: '已登记',
        1: '已返厂'
      },
      search: {
        storeId: null,
        storeName: null,
        provinceCode: null,
        cityCode: null,
        contactMobile: null,
        categoryList: [],
        barcode: null,
        status: null,
        startRegisterDate: null,
        endRegisterDate: null,
        startCheckDate: null,
        endCheckDate: null,
        sample: null,
        consistent: null,
        page: 1,
        rows: 10
      },
      batchDialogVisible: false,
      showBatchUpload: true,
      batchUpLoadData: {}
    }
  },
  computed: {
    // 登记时间：一年前至当日，未来不可选
    registerTimeOptions() {
      return this.timePickerOptions()
    },
    // 抽检时间：一年前至当日，未来不可选
    checkTimeOptions() {
      return this.timePickerOptions()
    }
  },
  watch: {
    batchDialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          if (!this.global.handleEmptyData(this.batchUpLoadData)) {
            this.$refs.batchFileRef && this.$refs.batchFileRef.$refs.upload.clearFiles()
          }
          this.batchUpLoadData = {}
          this.showBatchUpload = true
        }, 100)
      }
    }
  },
  mounted() {
    this.getProvinceList()
    this.getCategoryList()
    this.getList()
  },
  methods: {
    // 获取回收品类
    async getCategoryList() {
      let { data, statusCode } = await getCategory()
      if (statusCode == 200 && data) {
        this.categoryList = data.map(item => ({
          value: item.code,
          label: item.desc
        }))
      }
    },
    // 获取省份列表
    async getProvinceList() {
      let { data, statusCode } = await findAllProvince()
      if (statusCode == 200) {
        this.provinceList = data || []
      }
    },
    // 获取城市列表
    async getCityList(provinceCode) {
      this.cityList = []
      if (!provinceCode) return
      let { data, statusCode } = await findAllCity(provinceCode)
      if (statusCode == 200) {
        this.cityList = data || []
      }
    },
    provinceChange(val) {
      this.search.cityCode = null
      this.getCityList(val)
    },
    // 时间选择范围：截至系统当日，最早可选择一年前，当日之后不可选中
    timePickerOptions() {
      return {
        disabledDate(time) {
          // 从当天 0 点开始计算
          const now = new Date()
          const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
          // 一年前当天 0 点
          const oneYearAgo = new Date(todayStart)
          oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1)
          const t = time.getTime()
          return t > todayStart.getTime() || t < oneYearAgo.getTime()
        }
      }
    },
    // 登记时间选择
    changeRegisterTime() {
      if (this.registerTime && this.registerTime.length) {
        this.search.startRegisterDate = this.registerTime[0] + ' 00:00:00'
        this.search.endRegisterDate = this.registerTime[1] + ' 23:59:59'
      } else {
        this.search.startRegisterDate = null
        this.search.endRegisterDate = null
      }
    },
    // 抽检时间选择
    changeCheckTime() {
      if (this.checkTime && this.checkTime.length) {
        this.search.startCheckDate = this.checkTime[0] + ' 00:00:00'
        this.search.endCheckDate = this.checkTime[1] + ' 23:59:59'
      } else {
        this.search.startCheckDate = null
        this.search.endCheckDate = null
      }
    },
    // 查询
    handleSearch() {
      this.search.page = 1
      this.getList()
    },
    async getList() {
      this.listLoading = true
      let { data, statusCode } = await getOldDeviceList(this.search)
      if (statusCode == 200) {
        this.list = (data && data.records) || []
        this.total = (data && data.total) || 0
      } else {
        this.list = []
      }
      this.listLoading = false
    },
    resetForm() {
      this.search = this.$options.data().search
      this.cityList = []
      this.registerTime = []
      this.checkTime = []
      this.getList()
    },
    handleSizeChange(val) {
      this.search.page = 1
      this.search.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 详情
    goDetail(row) {
        this.$router.push(`/thirdPartyTradeIn/oldDeviceQuery/detail?id=${row.barcode}`)
    },
    // 入库（单条/多条，勾选）
    inbound() {
      const selected = this.$refs.checktableData.selection || []
      if (!selected.length) {
        this.$message.warning('请先勾选要入库的旧机数据')
        return
      }
      // 校验状态必须为已登记
      const notRegistered = selected.filter(item => item.status !== 0)
      if (notRegistered.length) {
        this.$message.warning('存在已入库的旧机，请勿重复操作')
        return
      }
      this.$confirm(`确认将选中的 ${selected.length} 条旧机入库吗？`, '入库确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 入库接口以旧机条码标识，选中行为已登记
          this.doInbound(selected.map(item => item.barcode))
        })
        .catch(() => {})
    },
    async doInbound(barcodes) {
      let { statusCode, message } = await inboundOldDevice(barcodes)
      if (statusCode == 200) {
        this.$message.success('入库成功')
        this.handleSearch()
      } else {
        this.$message.error(message || '入库失败')
      }
    },
    // 打开批量入库弹窗
    openBatchDialog() {
      this.batchDialogVisible = true
    },
    // 选择批量入库文件
    batchFileAdd(item) {
      this.batchUpLoadData = item
    },
    // 移除批量入库文件
    removeBatchFile() {
      this.showBatchUpload = true
      this.batchUpLoadData = {}
    },
    // 确认批量入库
    submitBatchImport() {
      if (this.global.handleEmptyData(this.batchUpLoadData)) {
        this.$message.error('请上传文件')
        return
      }
      let formData = new FormData()
      formData.append('file', this.batchUpLoadData.file)
      importInbound(formData).then(res => {
        if (res.statusCode !== 200) {
          return this.$message.error(res.message || '批量入库失败')
        }
        if (res.data != null && res.data != "") {
          this.$message.error('文件有误, 请查看错误报告')
          this.getErrorReport(res.data)
        } else {
          this.$message.success('批量入库成功')
          this.batchDialogVisible = false
          this.handleSearch()
        }
      })
    },
    // 批量入库模板下载
    downloadImportTemplate() {
      this.global.exportExcel('/autoapp-default-server-recovery/api/file/downLoadTemplate', { templateName: 'ThirdPartyOldMachineExcel' }, '批量入库模板').catch(res => {
        let blob = new Blob([res.response.data], { type: 'application/json' })
        new Response(blob).json().then(r => this.$message.error(r.message))
      })
    },

    // 下载错误报告
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], { type: 'application/json' })
        new Response(blob).json().then(r => this.$message.error(r.message))
      })
    },
    // 导出
    exportExcel() {
      let url = '/autoapp-default-server-recovery/api/third-party/oldMachine/excelPageCondition'
      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .batch-storage-button {
    margin-left: 10px;
    margin-right: 10px;
  }
  .right-buttons {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
}
.font-blod {
  font-weight: bold;
}
.btnclass {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
.tableBtn {
  display: flex;
  justify-content: flex-end;
  div {
    // padding: 6px 16px;
    cursor: pointer;
    // border-radius: 4px;
  }
  div:last-child {
    background: #29b26b;
    color: #fff;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/thirdPartyTradeIn/oldDeviceQuery/list.vue